import CityPageTemplate from "../city-template/CityPageTemplate";
import { vermillionConfig } from "./data";

export default function VermillionPage() {
  return <CityPageTemplate config={vermillionConfig} />;
}